import { useQuery } from '@tanstack/react-query'
import { registrosApi } from '@/modules/registros/api/registros.api'

export function useEstadisticasReporte(configId: number, filtros?: Record<string, string>) {
  return useQuery({
    queryKey: ['reporte-estadisticas', configId, filtros],
    queryFn: () => registrosApi.getEstadisticas(configId, filtros),
    enabled: !!configId,
  })
}

export function useDatosGraficos(configId: number, filtros?: Record<string, string>) {
  return useQuery({
    queryKey: ['reporte-graficos', configId, filtros],
    queryFn: () => registrosApi.getDatosGraficos(configId, filtros),
    enabled: !!configId,
  })
}

export function useInsights(configId: number, filtros?: Record<string, string>) {
  return useQuery({
    queryKey: ['reporte-insights', configId, filtros],
    queryFn: () => registrosApi.getInsights(configId, filtros),
    enabled: !!configId,
  })
}

export function useRegistros(
  configId: number,
  params?: {
    page?: number
    page_size?: number
    ordenar_por?: string
    filtros?: Record<string, string>
    busqueda?: string
  }
) {
  return useQuery({
    queryKey: ['reporte-registros', configId, params],
    queryFn: () => registrosApi.getRegistros(configId, params),
    enabled: !!configId,
  })
}

export function useValoresFiltro(configId: number, campo: string) {
  return useQuery({
    queryKey: ['reporte-valores-filtro', configId, campo],
    queryFn: () => registrosApi.getValoresFiltro(configId, campo),
    enabled: !!configId && !!campo,
  })
}
